export const DEVICE_ID_STORAGE_KEY = 'deviceId';
export const USER_INFO_STORAGE_KEY = 'wp_user:info';
export const USER_LOGIN_DOMAINS_STORAGE_KEY = 'wp:login_domains';
